export default "__VITE_PUBLIC_ASSET__1fdaed83__"